var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from '../icon/icon';
import './button.scss';
import { Loader } from './loader';
export var Button = function (_a) {
    var type = _a.type, variant = _a.variant, size = _a.size, width = _a.width, dataValue = _a.dataValue, disabled = _a.disabled, childClasses = _a.childClasses, icon = _a.icon, iconPosition = _a.iconPosition, textHidden = _a.textHidden, onClick = _a.onClick, children = _a.children, hiddenInLargerScreens = _a.hiddenInLargerScreens, loadingBar = _a.loadingBar, name = _a.name;
    var btnClasses = "c-btn c-btn--".concat(variant);
    if (size) {
        btnClasses += " c-btn--".concat(size);
    }
    if (width === 'full') {
        btnClasses += " u-width-100";
    }
    if (disabled) {
        btnClasses += " disabled";
    }
    if (childClasses) {
        btnClasses += " ".concat(childClasses);
    }
    if (iconPosition === 'left') {
        btnClasses += ' c-btn--icon-left';
    }
    if (iconPosition === 'right') {
        btnClasses += ' c-btn--icon-right';
    }
    if (textHidden) {
        btnClasses += ' c-btn--text-hidden';
    }
    if (hiddenInLargerScreens) {
        btnClasses += " c-btn__larger_screens_hidden";
    }
    return (React.createElement("button", __assign({ type: type, className: btnClasses, disabled: disabled }, (dataValue && { 'data-value': dataValue }), { onClick: onClick, name: name }),
        icon && (iconPosition === 'left' || textHidden) && React.createElement(Icon, { name: icon }),
        React.createElement("span", null, children),
        icon && iconPosition === 'right' && React.createElement(Icon, { name: icon }),
        loadingBar && React.createElement(Loader, { size: "16px" })));
};
